export default "__VITE_ASSET__ONlWqHtu__"